import { Plus } from 'lucide-react';
import { TableActionMenu, type TableActionItem } from '@/components/shared';
import { useMediaQuery } from '@/lib/use-media-query';

export interface VouchersPageActionsProps {
  onCreateVoucher: () => void;
}

export function VouchersPageActions({ onCreateVoucher }: VouchersPageActionsProps) {
  const isMobile = useMediaQuery('(max-width: 767px)');

  const createAction: TableActionItem = {
    id: 'create-voucher',
    label: 'New voucher',
    icon: Plus,
    onSelect: onCreateVoucher,
  };

  if (isMobile) {
    return <TableActionMenu actions={[createAction]} label="Voucher page actions" />;
  }

  return (
    <div className="flex items-center gap-2">
      <button
        type="button"
        className="focus-ring inline-flex h-10 items-center gap-1.5 whitespace-nowrap rounded-lg border border-backoffice-500 bg-backoffice-500 px-3 text-small font-medium text-white hover:bg-backoffice-600"
        onClick={onCreateVoucher}
      >
        <Plus className="h-4 w-4" aria-hidden="true" />
        New voucher
      </button>
    </div>
  );
}
